import React, { useState, useRef, useEffect } from "react";

import {
  Dialog,
  DialogProps,
  DialogActions,
  Button,
  Grid,
} from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers";

const getLastDayOfLastMonth = (today: Date): Date => {
  today.setDate(0);
  return today;
};

export const DatePickerModal = ({
  open,
  onClose,
  referenceDate,
  onDateChange,
  yearOnly = false,
}: DatePickerModalProps) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const maxDate = useRef<Date>(getLastDayOfLastMonth(new Date()));

  useEffect(() => {
    setSelectedDate(referenceDate);
  }, [referenceDate]);

  const handleSelection = () => {
    if (selectedDate) {
      onDateChange(selectedDate);
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <Grid container>
        <DateCalendar
          value={selectedDate || referenceDate}
          disableHighlightToday
          maxDate={maxDate.current}
          onChange={setSelectedDate}
          views={yearOnly ? ["year"] : ["year", "month"]}
          openTo={yearOnly ? "year" : "month"}
        />
      </Grid>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="contained" onClick={handleSelection}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export type DatePickerModalProps = {
  open: DialogProps["open"];
  referenceDate: Date | null;
  onDateChange: (arg: Date) => void;
  onClose: () => void;
  yearOnly?: boolean;
};
